import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const UserIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M7 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM2.041 12c.165-.466.98-2 4.96-2 3.978 0 4.793 1.534 4.958 2H2.04Zm4.96-3.5C1.546 8.5.5 11.243.5 12.123c0 .879.71 1.377 1.374 1.377h10.252c.663 0 1.374-.498 1.374-1.377 0-.88-1.047-3.623-6.5-3.623Z"/>
    </svg>
);
UserIcon.displayName = 'UserIcon';
export default UserIcon;
